var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 1.2C2.4 1.86274 1.86274 2.4 1.2 2.4C0.537258 2.4 0 1.86274 0 1.2C0 0.537258 0.537258 0 1.2 0C1.86274 0 2.4 0.537258 2.4 1.2Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 6.00078C2.4 6.66352 1.86274 7.20078 1.2 7.20078C0.537258 7.20078 0 6.66352 0 6.00078C0 5.33804 0.537258 4.80078 1.2 4.80078C1.86274 4.80078 2.4 5.33804 2.4 6.00078Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 10.8016C2.4 11.4643 1.86274 12.0016 1.2 12.0016C0.537258 12.0016 0 11.4643 0 10.8016C0 10.1388 0.537258 9.60156 1.2 9.60156C1.86274 9.60156 2.4 10.1388 2.4 10.8016Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01953 1.20187C4.01953 0.771093 4.36875 0.421875 4.79953 0.421875H16.7995C17.2303 0.421875 17.5795 0.771093 17.5795 1.20187C17.5795 1.63266 17.2303 1.98187 16.7995 1.98187H4.79953C4.36875 1.98187 4.01953 1.63266 4.01953 1.20187ZM4.01953 6.00187C4.01953 5.57109 4.36875 5.22187 4.79953 5.22187H16.7995C17.2303 5.22187 17.5795 5.57109 17.5795 6.00187C17.5795 6.43266 17.2303 6.78187 16.7995 6.78187H4.79953C4.36875 6.78187 4.01953 6.43266 4.01953 6.00187ZM4.01953 10.8019C4.01953 10.3711 4.36875 10.0219 4.79953 10.0219H16.7995C17.2303 10.0219 17.5795 10.3711 17.5795 10.8019C17.5795 11.2327 17.2303 11.5819 16.7995 11.5819H4.79953C4.36875 11.5819 4.01953 11.2327 4.01953 10.8019Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartIcon);
export default __webpack_public_path__ + "static/media/bar-chart-icon.b452589315b78c48e38d0668f1bf3139.svg";
export { ForwardRef as ReactComponent };